"use client";

import EventsImage from "../../assets/images/events.png";
import { SchoolFeedMobileWidgetLink } from "./SchoolFeedMobileWidgetLink";
import { withLocaleInURI } from "../../internationalization/i18nURI";
import { useStores } from "../../stores/useStores";
import { getQueries } from "../../utils/SchoolBlocksUtilities";

export function MobileEventsWidgetLink(props: { active: boolean }) {
  const { i18nStore, interfaceStore } = useStores();
  const query = getQueries(interfaceStore.currentFullUrl);

  return (
    <SchoolFeedMobileWidgetLink
      href={{
        pathname: withLocaleInURI(
          "/calendar",
          i18nStore.currentAppSupportedLocale,
        ),
        query,
      }}
      active={props.active}
      src={EventsImage}
      text={"Events"}
      color={"red"}
    />
  );
}
